module.exports = __webpack_public_path__ + "static/media/anteater.7d9db79f.jpeg";